import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import HeadSub from '../../../components/comm/HeadSub';
import SwitchBox from '../../../components/box/SwitchBox';
import style from './AlarmIntensity.module.css';

const LEVEL_LABELS = ['느슨하게', '보통', '꼼꼼하게'];

const MARKS = [
    { value: 0, label: '느슨하게' },
    { value: 1, label: '보통' },
    { value: 2, label: '꼼꼼하게' },
];

// MUI Slider 커스텀 (이미지 톤: 파란 트랙/썸, 회색 레일)
const IntensitySlider = styled(Slider)(() => ({
    color: '#3284FF',
    height: 6,
    padding: '13px 0',
    '& .MuiSlider-rail': {
        backgroundColor: '#D9DDE3',
        opacity: 1,
        height: 6,
        borderRadius: 3,
    },
    '& .MuiSlider-track': {
        border: 'none',
        height: 6,
        borderRadius: 3,
    },
    '& .MuiSlider-thumb': {
        width: 22,
        height: 22,
        backgroundColor: '#fff',
        border: '3px solid #3284FF',
        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
        '&:hover, &.Mui-focusVisible, &.Mui-active': {
            boxShadow: '0 2px 8px rgba(50,132,255,0.4)',
        },
    },
    '& .MuiSlider-mark': {
        display: 'none', // 눈금점 숨김 (라벨만 하단 커스텀 표시)
    },
    '& .MuiSlider-markLabel': {
        display: 'none', // 기본 라벨 숨김 → 커스텀 라벨 사용
    },
}));

// 각 알림 항목
const AlarmItem = ({ title, showLevelBox }) => {
    const [enabled, setEnabled] = useState(true);
    const [level, setLevel] = useState(1); // 0~2, 기본 보통

    return (
        <div className={style.card}>
            <div className={style.cardHead}>
                <strong className={style.cardTitle}>{title}</strong>
                <SwitchBox toggles={enabled} status={setEnabled} />
            </div>

            {showLevelBox && (
                <div className={style.levelBox}>
                    알림 강도 : <b>{LEVEL_LABELS[level]}</b>
                </div>
            )}

            <div className={style.sliderWrap} data-disabled={!enabled ? 'true' : undefined}>
                <IntensitySlider
                    value={level}
                    onChange={(_, v) => setLevel(v)}
                    step={1}
                    min={0}
                    max={2}
                    marks={MARKS}
                    disabled={!enabled}
                />
                <div className={style.sliderLabels}>
                    {LEVEL_LABELS.map((l, i) => (
                        <span key={i} className={level === i ? style.labelActive : ''}>{l}</span>
                    ))}
                </div>
            </div>
        </div>
    );
};

const AlarmIntensity = () => {
    const navigate = useNavigate();

    return (
        <>
            <HeadSub title="알림 강도 설정" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-pad="normal">
                    <p className={style.desc}>
                        알림 횟수와 간격, 시간을 강도별로 조절해 보세요.<br />
                        강도가 높을수록 알림이 더 자주, 반복해서 울립니다.
                    </p>

                    <div className={style.list}>
                        <AlarmItem title="식이 기록 알림" />
                        <AlarmItem title="운동 기록 알림" />
                        <AlarmItem title="목표 달성 알림" showLevelBox />
                        <AlarmItem title="리포트 생성 알림" showLevelBox />
                    </div>
                </div>
            </div>
        </>
    );
};

export default AlarmIntensity;